import { useSettingsStore } from '@/stores/settings';

export const useConvention = () => {
	const settingsStore = useSettingsStore();

	const format = (numero: number, nom: string, date: string | null): string => {
		return settingsStore.formatPiece(numero, nom, date);
	};

	const preview = (template: string): string => {
		return template.replace('{numero}', '3').replace('{nom}', 'Contrat de bail').replace('{date}', '15/03/2024');
	};

	return { format, preview };
};
